module.exports = __webpack_public_path__ + "media/trailer.5f098346.mp4";